<template>
    <ul class="wiki-lang-wrapper">
        <li v-for="(item, index) in options" :key="index" @click="langClick(item, index)" :class="{ active: item.value === activeLang }">
            {{ $t(item.i18nKey) }}
        </li>
    </ul>
</template>

<script>
import { businessLangs } from "@/components/langSelect/languages.js";

const langOptions = () => {
    return businessLangs().map(lang => {
        return {
            value: lang.lang,
            i18nKey: lang.i18nKey
        };
    });
};

export default {
    name: "WikiLanguage",
    props: ["currentLang"],
    components: {},
    data() {
        return {
            activeLang: this.currentLang || "en"
        };
    },
    computed: {
        options() {
            return langOptions();
        }
    },
    watch: {},
    methods: {
        langClick(item) {
            this.activeLang = item.value;
            this.$emit("langSelect", item.value);
        }
    }
};
</script>

<style lang="scss" scoped>
.wiki-lang-wrapper {
    font-size: 14px;
    overflow-y: auto;
    width: 100%;

    li {
        height: 60px;
        line-height: 60px;
        text-align: center;
        cursor: pointer;
    }

    .active {
        background-color: #d9ebf6;
        color: #2ec2ff;
    }
}
</style>
